import {
  ScanLine,
  Wrench,
  Printer,
  ChevronRight,
  ChevronDown,
} from "lucide-react";

import { useFadeInScroll } from "../Animation/fadeinScroll";
const workflow = [
  {
    title: "Scan",
    text: "High-precision digital scanning captures exact anatomical data to ensure a perfectly tailored orthopedic solution.",
    icon: ScanLine,
  },
  {
    title: "Create",
    text: "Patient-specific design is engineered using advanced algorithms for optimal comfort, stability, and healing.",
    icon: Wrench,
  },
  {
    title: "Print",
    text: "Medical-grade 3D printing delivers a lightweight, breathable, and durable cast built to clinical standards.",
    icon: Printer,
  },
];

const AboutBodySection = () => {
  const title = useFadeInScroll<HTMLDivElement>();
  return (
    <section className=" bg-bg-primary">
      <div className="max-w-7xl mx-auto">

        {/* Header */}
        <div
          ref={title.ref}
          className={`
              transition-all duration-[900ms] ease-[cubic-bezier(0.22,1,0.36,1)]
              ${title.isVisible
              ? "opacity-100 translate-y-0"
              : "opacity-0 translate-y-6"}
            `}
        >
          <div className="max-w-3xl mb-16">
            <h2 className="text-subtitle text-primary font-primary mb-4">
              Our Workflow
            </h2>
            <p className="text-body text-text-secondary">
              A connected, step-by-step process from scan to final product.
            </p>
          </div>
        </div>
        {/* ================= WORKFLOW ================= */}
        <div className="relative">

          {/* Desktop Spine */}
          <div className="hidden lg:block absolute top-[72px] left-0 right-0 h-[2px] bg-primary/30" />

          {/* Mobile Spine */}
          <div className="lg:hidden absolute left-1/2 top-0 bottom-0 w-[2px] bg-primary/30 -translate-x-1/2" />

          <div className="relative flex flex-col lg:flex-row justify-between gap-20 lg:gap-8">

            {workflow.map((item, index) => (
              <div
                key={index}
                className="relative flex flex-col items-center lg:flex-1"
              >
                {/* ================= DESKTOP ARROW ================= */}
                {index < workflow.length - 1 && (
                  <div
                    className="
                      hidden lg:flex
                      absolute top-[58px]
                      right-[-26px]
                      z-0
                      items-center
                      text-primary
                    "
                  >
                    <ChevronRight size={32} strokeWidth={2.5} />
                  </div>
                )}

                {/* ================= MOBILE ARROW ================= */}
                {index < workflow.length - 1 && (
                  <div
                    className="
                      lg:hidden
                      absolute
                      -bottom-12
                      left-1/2
                      -translate-x-1/2
                      flex
                      flex-col
                      items-center
                      text-primary
                    "
                  >
                    <div className="w-[2px] h-8 bg-primary/40 mb-2" />
                    <ChevronDown size={28} strokeWidth={2.5} />
                  </div>
                )}

                {/* Icon Node */}
                <div
                  className="
                    relative z-10
                    mb-6
                    w-16 h-16
                    flex items-center justify-center
                    rounded-2xl
                    bg-white
                    border-2 border-primary
                    text-primary
                  "
                >
                  <item.icon size={30} strokeWidth={1.8} />
                </div>

                {/* Card */}
                <div
                  className="
                    w-full max-w-sm
                    p-8
                    bg-white
                    border border-border-primary
                    rounded-2xl
                    text-center
                    shadow-sm
                  
                    transition-all duration-300
                  "
                >
                  <h3 className=" mb-3 text-subtitle text-primary font-primary ">
                    {item.title}
                  </h3>

                  <p className="text-body text-text-secondary leading-relaxed">
                    {item.text}
                  </p>
                </div>
              </div>
            ))}

          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutBodySection;
